var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51C2CD41-7F3E-4D27-9A8E-3CF66F03F1A9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-page-Full",
    transform: "translate(-261, -569)",
    stroke: "#256BFD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Audience",
    transform: "translate(24, 494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secret-Fans-Copy",
    transform: "translate(171, 43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons_24/Lost_Followers",
    transform: "translate(66, 32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3, 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,15 L20,15 M10,12.5 L5.5,12.5 C4.10444,12.5 3.40665,12.5 2.83886,12.6722 C1.56045,13.06 0.56004,14.0605 0.17224,15.3389 C0,15.9067 0,16.6044 0,18 M12.5,4.5 C12.5,6.98528 10.4853,9 8,9 C5.51472,9 3.5,6.98528 3.5,4.5 C3.5,2.01472 5.51472,0 8,0 C10.4853,0 12.5,2.01472 12.5,4.5 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.496450dcc957753d3b2a9382f3af80da.svg";
export { ForwardRef as ReactComponent };